import React from "react";
import styled from "styled-components";
import { Button } from "components/generic/kit";
import { ErrorBox } from "components/generic/form/service";

const Text = styled.div`
  line-height: 1.3;
  font-size: ${({ size = "16px" }) => size};
  color: #bcbcbc;
  font-family: CircularStd-Book, sans-serif;
`;

export default ({
  onSubmit,
  error,
  promoCode,
  serverErrors,
  isPaying,
  completeText,
  nodeId,
  total
}) => (
  <div className="ph0-ns ph3">
    {error && <div className="red f6">{error}</div>}
    {!!serverErrors.nonField.length && (
      <ErrorBox errors={serverErrors.nonField} />
    )}
    <form onSubmit={onSubmit}>
      <div className="mt2 mb1 pa2 br2 ba b--moon-gray mw6 w-100" id={nodeId} />
      <div className="mb2 mw6 w-100">
        <Text size="12px" className="mr2">
          We never store your credit card info, Stripe protects it and we can
          never see more than your last 4 digits.
        </Text>
        {total}
        {promoCode}
        <Text className="mr2 mt3">
          Please note: You are NOT buying referrals, jobs, or real interviews.
          Our Insiders are here to provide honest feedback and answers any
          questions you may have.
        </Text>
      </div>
      <div className="pa3">
        <Button size="small" color="white" disabled={isPaying}>
          {completeText}
        </Button>
      </div>
    </form>
  </div>
);



// WEBPACK FOOTER //
// ./src/components/pages/Candidate/Payment/components/Stripe/View.js